import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  SortDirection,
  type PagePaginationRequestDto,
} from '../../lib';
import { MarketFacilityListItemDtoSchema } from '../contracts';

const GetMarketFacilitiesResponseDtoSchema = PagePaginationResponseDtoSchema(
  MarketFacilityListItemDtoSchema
);

export type GetMarketFacilitiesRequestDto = PagePaginationRequestDto<
  {
    search?: string | null;
  },
  'name'
>;
export type GetMarketFacilitiesResponseDto = z.infer<
  typeof GetMarketFacilitiesResponseDtoSchema
>;

export const getMarketFacilities = (
  params: GetMarketFacilitiesRequestDto,
  config?: AxiosRequestConfig<GetMarketFacilitiesRequestDto>
) => {
  const transformedParams: GetMarketFacilitiesRequestDto = {
    sortDirection: SortDirection.DESC,
    sortBy: 'name',
    ...params,
    search: params.search?.trim() ? params.search.trim() : null,
  };

  return api
    .get('/market-facilities', {
      params: transformedParams,
      ...config,
    })
    .then(responseContract(GetMarketFacilitiesResponseDtoSchema));
};
